export default function downloadBlob(blob: Blob | File, filename?: string) {
  const a = document.createElement('a');
  a.download = filename || (blob as File).name || 'download';
  a.rel = 'noopener';
  a.href = URL.createObjectURL(blob);
  setTimeout(() => URL.revokeObjectURL(a.href), 4e4);
  setTimeout(() => {
    try {
      a.dispatchEvent(new MouseEvent('click'));
    } catch (e) {
      const evt = document.createEvent('MouseEvents');
      evt.initMouseEvent(
        'click',
        true,
        true,
        window,
        0,
        0,
        0,
        80,
        20,
        false,
        false,
        false,
        false,
        0,
        null,
      );
      a.dispatchEvent(evt);
    }
  }, 0);
}
